import React from 'react';
import { ProductConfigurator } from '../components/signshop/ProductConfigurator';

export const VistaprintShop: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-7xl mx-auto mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Vistaprint Shop</h1>
        <p className="text-gray-500 mt-1">Curated catalog with size, material, and quantity tiers.</p>
      </div>
      <div className="max-w-7xl mx-auto">
        <ProductConfigurator />
      </div>
    </div>
  );
};
